module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_finance-dee2a4c8.png";